import React from "react";

import Category from "./Category";

const SingleCategory = () => {
  return <Category />;
};

export default SingleCategory;